export default "<p>cmadatareports works!</p>\n"